import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { TraditumDetalleContent } from './components/TraditumDetalleContent';

export default function TraditumDetalle() {
    return (
        <>
            <MainContent
                component={<TraditumDetalleContent />}
                titulo='Solicitud de Validación de Prácticas'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
